import React, { useState, useEffect } from "react";
import { mediaUrl } from "../../utils/mediaUrl";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Mousewheel } from "swiper/modules";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import { openBannerLink } from '../../utils/bannerLink';

import "swiper/css";
import "swiper/css/pagination";

import "../../css/bannerSlider.css";

const BannerSlider = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const loadBanners = async () => {
      try {
        const { data } = await api.get('/banner-sliders');
        const list = (data || [])
          .filter((b) => b.isActive)
          .sort((a, b) => (a.order || 0) - (b.order || 0));
        setBanners(list);
      } catch (err) {
        console.error('Failed to load banner slides', err);
      } finally {
        setLoading(false);
      }
    };
    loadBanners();
  }, []);

  if (loading || banners.length === 0) return null;

  return (
    <section className="banner-wrapper m-hero" aria-label="Featured collections">
      <div className="m-hero-frame">
        <span className="m-hero-corner is-tl" aria-hidden="true" />
        <span className="m-hero-corner is-br" aria-hidden="true" />

        <Swiper
          modules={[Autoplay, Pagination, Mousewheel]}
          slidesPerView={1}
          loop={banners.length > 1}
          speed={650}
          grabCursor
          simulateTouch
          allowTouchMove
          threshold={6}
          resistanceRatio={0.65}
          touchEventsTarget="container"
          mousewheel={
            banners.length > 1
              ? {
                  forceToAxis: true,
                  releaseOnEdges: true,
                  thresholdDelta: 18,
                  thresholdTime: 350,
                  sensitivity: 0.7
                }
              : false
          }
          autoplay={{ delay: 5200, disableOnInteraction: false, pauseOnMouseEnter: true }}
          pagination={banners.length > 1 ? { clickable: true } : false}
          onClick={(s) => {
            const banner = banners[s.realIndex];
            if (banner && !banner.title && !banner.subtitle) {
              openBannerLink(navigate, banner.link, banner.title);
            }
          }}
        >
          {banners.map((banner, i) => (
            <SwiperSlide key={banner._id} className="m-hero-slide">
              <div className="m-hero-media">
                <picture>
                  {banner.mobileImage && <source media="(max-width: 700px)" srcSet={mediaUrl(banner.mobileImage)} />}
                  <img
                    src={mediaUrl(banner.image)}
                    alt={banner.title || 'Mithralaya collection'}
                    loading={i === 0 ? 'eager' : 'lazy'}
                    fetchpriority={i === 0 ? 'high' : 'auto'}
                  />
                </picture>
                <div className="m-hero-veil" aria-hidden="true" />
              </div>

              {(banner.title || banner.subtitle) && (
                <div className="m-hero-copy">
                  <p className="m-hero-kicker">Mithralaya collection</p>
                  {banner.title && <h2>{banner.title}</h2>}
                  {banner.subtitle && <p className="m-hero-sub">{banner.subtitle}</p>}
                  <button
                    type="button"
                    className="m-hero-btn"
                    onClick={() => openBannerLink(navigate, banner.link, banner.title)}
                  >
                    {(banner.buttonText || 'Shop the collection').slice(0, 28)}
                    <span aria-hidden="true">→</span>
                  </button>
                </div>
              )}

            </SwiperSlide>
          ))}
        </Swiper>

      </div>
    </section>
  );
};

export default BannerSlider;
